import { Header } from "./Header.mjs";
import { Shape } from "./Shape.mjs";
import { Text } from "./Text.mjs";
import { Button } from "./Button.mjs";
const Skeleton = {
  Header,
  Shape,
  Text,
  Button
};
export {
  Skeleton
};
